export type DdayTone = 'urgent' | 'soon' | 'normal' | 'always' | 'closed';

export interface DdayInfo {
  /** 뱃지에 그대로 노출되는 라벨 (예: "🔥 D-5") */
  label: string;
  /** 짧은 표기 (예: "D-5") */
  short: string;
  tone: DdayTone;
  /** 남은 일수 (상시/파싱불가 시 null) */
  days: number | null;
}

const DAY_MS = 1000 * 60 * 60 * 24;

/**
 * 마감일("YYYY-MM-DD" 또는 "상시")을 받아 렌더 시점 기준 D-day 정보를 계산합니다.
 */
export function getDday(deadline: string, now: Date = new Date()): DdayInfo {
  if (!deadline || deadline === '상시') {
    return { label: '🟢 상시접수', short: '상시', tone: 'always', days: null };
  }

  const target = new Date(`${deadline}T00:00:00`);
  if (Number.isNaN(target.getTime())) {
    return { label: '🟢 상시접수', short: '상시', tone: 'always', days: null };
  }

  const base = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const tgt = new Date(target.getFullYear(), target.getMonth(), target.getDate());
  const days = Math.round((tgt.getTime() - base.getTime()) / DAY_MS);

  if (days < 0) return { label: '⛔ 접수마감', short: '마감', tone: 'closed', days };
  if (days === 0) return { label: '🔥 오늘 마감', short: 'D-DAY', tone: 'urgent', days };
  if (days <= 7) return { label: `🔥 마감 D-${days}`, short: `D-${days}`, tone: 'urgent', days };
  if (days <= 21) return { label: `⏱️ D-${days}`, short: `D-${days}`, tone: 'soon', days };
  return { label: `📅 D-${days}`, short: `D-${days}`, tone: 'normal', days };
}

export const DDAY_TONE_STYLE: Record<
  DdayTone,
  { background: string; color: string; border: string }
> = {
  urgent: { background: '#C23B3B', color: '#ffffff', border: 'rgba(255,255,255,0.38)' },
  soon: { background: '#D98324', color: '#ffffff', border: 'rgba(255,255,255,0.38)' },
  normal: { background: 'rgba(255,255,255,0.92)', color: '#141210', border: 'rgba(255,255,255,0.55)' },
  always: { background: '#3E8E5A', color: '#ffffff', border: 'rgba(255,255,255,0.38)' },
  closed: { background: 'rgba(0,0,0,0.55)', color: 'rgba(255,255,255,0.85)', border: 'rgba(255,255,255,0.25)' },
};